import React, { useEffect } from "react";
import Footer from "../../components/website/Footer";
import HeaderConferences from "../../components/website/HeaderConferences";
import Breadcrumbs from "../../components/Breadcrumbs";

function Cancelation() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            <HeaderConferences />
            <main>
                <section>
                    <div className="container">
                        <div class="breadcrumbs-about breadcrumbs-add">
                            <ul>
                                <li className="andThisStyle title-breadcrumbs">MAIN</li>
                                <li className="thisStyle description-breadcrumbs">
                                    Cancelation policy
                                </li>
                            </ul>
                            <Breadcrumbs />
                        </div>
                        <h2 className="title-conferences title-contact-us event-contact-us">
                            Cancelation policy
                        </h2>
                        <div className="line-conferences line-contact-us line-event-us">
                            <span className="line-about"></span>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <h3 className="title-terms">Cancellations and Substitutions:</h3>
                        <p className="text-terms">
                            A delegate may be substituted up to 2 days before the event. 30
                            days prior the event, or in case of non-attendance – no free
                            cancellation applicable *31-90 days prior the event – 50%
                            participation fee can be refunded * more than 91 days prior the
                            event – 75% participation fee can be refunded ****Refunds will be
                            made after the event. Substitutes are accepted up to 2 weeks
                            before the event.
                        </p>
                        <p className="text-terms">
                            Cancellation should take place in written form. Verbal
                            cancellations are not legally binding. 100% refund is possible in
                            Force Mature scenarios, such as: sickness of the delegate,
                            forbidden actions of the government authorities, civil strife,
                            epidemic, embargo, earthquakes, conflagrations, inundations and
                            other natural disasters, denial of the visa. All of the above
                            cases must be proved by legal documentation.
                        </p>
                        <h3 className="title-terms">
                            Force Majuro and Permanent Cancellation of Event:
                        </h3>
                        <p className="text-terms">
                            BCF reserves the right to change event dates, sites or location,
                            omit event features, or merge the event with another event as it
                            deems necessary without penalty and in such situations no refunds,
                            part refunds or alternative offers shall be made. In the event
                            that BCF permanently cancels the event for any reason whatever,
                            (including, but not limited to any force majeure occurrence) and
                            provided that the event is not postponed to a later date nor is it
                            merged with another event, the Client shall receive a credit note
                            for the amount that the Client has paid to such permanently
                            canceled event. No refunds, part refunds or alternative offers
                            shall be made.
                        </p>
                        <h3 className="title-terms">Copyright:</h3>
                        <p className="text-terms last-terms">
                            All intellectual property rights in all materials produced or
                            distributed by BCF in connection with this event are expressly
                            reserved and any unauthorized duplication, publication or
                            distribution is prohibited.
                        </p>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default Cancelation;
